import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-black rounded flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <div>
              <Link to="/" className="text-xl font-bold text-black">Worknetix Solutions</Link>
              <p className="text-xs text-gray-500">Staffing Solutions & Fino Bank</p>
            </div>
          </div>
        </div>
        <nav className="hidden md:flex items-center space-x-8">
          <Link to="/" className="text-gray-700 hover:text-black transition-colors">Home</Link>
          <Link to="/about" className="text-gray-700 hover:text-black transition-colors">About</Link>
          <Link to="/services" className="text-gray-700 hover:text-black transition-colors">Services</Link>
          <Link to="/contact" className="text-gray-700 hover:text-black transition-colors">Contact</Link>
        </nav>
        <button 
          onClick={toggleMenu}
          className="md:hidden text-gray-700 focus:outline-none"
          aria-label="Toggle menu"
        >
          {isMenuOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>
      
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            <Link 
              to="/" 
              onClick={closeMenu}
              className="text-gray-700 hover:text-black transition-colors py-2"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              onClick={closeMenu}
              className="text-gray-700 hover:text-black transition-colors py-2"
            >
              About
            </Link>
            <Link 
              to="/services" 
              onClick={closeMenu}
              className="text-gray-700 hover:text-black transition-colors py-2"
            >
              Services
            </Link>
            <Link 
              to="/contact" 
              onClick={closeMenu}
              className="text-gray-700 hover:text-black transition-colors py-2"
            >
              Contact
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
